<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.create_blank' | translate }}
    v-card-content
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :focus="true"
            :label="$t('base.farm_name')"
            v-model="payload.name")
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.struct_manager')"
            v-model="payload.structure_manager")
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.company')"
            v-model="payload.company_name")
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.farm_manager')"
            v-model="payload.farm_manager")
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.ind_code')"
            v-model="payload.ind_code")
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.zootechnic')"
            v-model="payload.zootechnics")
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.struct')"
            v-model="payload.structure_name")
        .cols-x__2
           v-text-field.mb-3(
             :label="$t('base.accountant')"
             v-model="payload.accountant")
      .cols-x
        .cols-x__2
          v-text-field.mb-3(
            :label="$t('base.farm')"
            v-model="payload.farm_full_name")
        .cols-x__2
           v-text-field(
             :label="$t('base.weigher')"
             v-model="payload.weigher")
      v-text-field(
        :label="$t('base.destination')"
        v-model="payload.appoint")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreate") {{ 'base.create' | translate }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CreateModal',

  data: () => ({
    payload: {
      name: '',
      company_name: '',
      ind_code: '',
      structure_name: '',
      farm_full_name: '',
      appoint: '',
      structure_manager: '',
      farm_manager: '',
      zootechnics: '',
      accountant: '',
      weigher: ''
    },
    loading: false
  }),

  methods: {
    ...mapActions('additional', [
      'createAdditional'
    ]),

    async onCreate () {
      this.loading = true
      const payload = {
        farm: this.$route.params.farm_id,
        ...this.payload
      }
      const error = await this.createAdditional(payload)
      this.loading = false
      if (!error) {
        this.$emit('close')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    }
  }
}
</script>
